import { render, staticRenderFns } from "./SpoGroups.vue?vue&type=template&id=cc99e1f0&scoped=true&"
import script from "./SpoGroups.vue?vue&type=script&lang=js&"
export * from "./SpoGroups.vue?vue&type=script&lang=js&"
import style0 from "./SpoGroups.vue?vue&type=style&index=0&id=cc99e1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc99e1f0",
  null
  
)

export default component.exports